(() => {
  'use strict';

  if (window.__enciaCalmReleasitCROV1) return;
  window.__enciaCalmReleasitCROV1 = true;

  const PRODUCT_ID = '10281789980968';
  const config = window.EnciaCalmReleasitCROConfig || {};
  const images = config.images || {};
  const OFFER_ORDER = [2, 4, 6];
  const OFFER_COPY = {
    2: {
      title: 'RECIBE 2 ENCIACALM',
      plaque: 'OFERTA 2×1',
      detail: 'PAGAS 1 Y RECIBES 2',
      image: images.two,
    },
    4: {
      title: 'RECIBE 4 ENCIACALM',
      plaque: '20% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $164.780 EN TOTAL',
      image: images.four,
    },
    6: {
      title: 'RECIBE 6 ENCIACALM',
      plaque: '40% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $258.405 EN TOTAL',
      image: images.six,
    },
  };

  const findFirst = (root, selectors) => {
    for (const selector of selectors) {
      const node = root.querySelector(selector);
      if (node) return node;
    }
    return null;
  };

  const onProductPage = () => {
    const path = window.location.pathname.replace(/\/$/, '').toLowerCase();
    if (path !== '/products/enciacalm') return false;
    const productId = document.querySelector('input[name="product_id"]')?.value;
    return !productId || productId === PRODUCT_ID;
  };

  const setEmailOptionalInSettings = (settings) => {
    const fields = settings?.form?.fields?.items_array;
    if (!Array.isArray(fields)) return;
    const email = fields.find((field) => field?.type === 'email');
    if (email) email.required = false;
  };

  const ensureEmailOptional = (root) => {
    setEmailOptionalInSettings(window._RSI_COD_FORM_SETTINGS);
    setEmailOptionalInSettings(window._rsi?.s);
    const input = root.querySelector('#_rsi-field-email, input[name="email"]');
    if (!input) return;
    input.required = false;
    input.removeAttribute('required');
    input.setAttribute('aria-required', 'false');
    input.dataset.ecOptional = 'true';
    const wrapper = input.closest('._rsi-modal-fields-item');
    const label = wrapper?.querySelector('label');
    if (label) {
      label.textContent = 'Correo electrónico (opcional)';
      label.dataset.ecEmailOptional = 'true';
    }
  };

  const ensureSubmitCopy = (root) => {
    const button = root.querySelector('button[type="submit"]._rsi-modal-submit-button');
    const total = button?.querySelector('.rsi-cod-form-submit-total-value');
    const holder = total?.parentElement;
    if (!button || !total || !holder) return;
    let prefix = [...holder.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    if (!prefix) {
      prefix = document.createTextNode('');
      holder.prepend(prefix);
    }
    prefix.textContent = 'PEDIR MI 2x1 — PAGAR AL RECIBIR — ';
    button.dataset.ecCtaCopy = 'true';
    button.setAttribute('aria-label', `Pedir mi 2x1, pagar al recibir, total ${total.textContent.trim()}`);
    button.style.setProperty('background', 'linear-gradient(135deg,#0f5c51,#1b8b78)', 'important');
    button.style.setProperty('color', '#ffffff', 'important');
    button.style.setProperty('border', '0', 'important');
    button.style.setProperty('border-radius', '14px', 'important');
    button.style.setProperty('box-shadow', '0 12px 24px rgba(15,92,81,.25)', 'important');
    button.style.setProperty('font-weight', '950', 'important');
  };

  const ensureDeliveryCopy = (root) => {
    const customTexts = [...root.querySelectorAll('._rsi-custom-text-field')];
    const fieldsHeading = customTexts.find((node) => /Escribe tus datos de envío/i.test(node.textContent));
    if (fieldsHeading) {
      fieldsHeading.textContent = '2 - Completa tus datos de entrega';
      fieldsHeading.dataset.ecDeliveryHeading = 'true';
      fieldsHeading.style.setProperty('color', '#0d5248', 'important');
      fieldsHeading.style.setProperty('font-weight', '900', 'important');
      let note = root.querySelector('.ec-releasit-delivery-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'ec-releasit-delivery-note';
        note.textContent = 'Te contactaremos por WhatsApp para confirmar el pedido.';
      }
      fieldsHeading.after(note);
    }
    const coverage = customTexts.find((node) => /municipio NO se despliega|transportadora no tiene cobertura/i.test(node.textContent));
    if (coverage) {
      coverage.textContent = 'Selecciona tu municipio para validar cobertura. Si no aparece, contáctanos y revisaremos una alternativa.';
      coverage.dataset.ecCoverageCopy = 'true';
      coverage.style.setProperty('color', '#315f58', 'important');
      coverage.style.setProperty('background', '#eefaf7', 'important');
    }
  };

  const ensureOfferIntro = (root) => {
    const heading = findFirst(root, ['._rsi-custom-text-field', '._rsi-quantity-offers-main-title']);
    if (!heading) return;
    heading.textContent = 'OFERTA 2x1: PAGA 1 Y RECIBE 2';
    heading.dataset.ecOfferHeading = 'true';
    heading.style.setProperty('color', '#0d5248', 'important');
    heading.style.setProperty('font-weight', '900', 'important');
    heading.style.setProperty('font-size', '20px', 'important');

    let summary = root.querySelector('.ec-releasit-cro-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'ec-releasit-cro-summary';
      const lead = document.createElement('strong');
      lead.textContent = `Recibe 2 sprays de EncíaCalm por ${config.basePriceText || 'el total indicado'} en total.`;
      const cod = document.createElement('span');
      cod.textContent = 'Envío incluido y pago contraentrega. Pagas cuando recibes tu pedido.';
      const instruction = document.createElement('span');
      instruction.textContent = 'Selecciona tu oferta y completa los datos de entrega.';
      summary.append(lead, cod, instruction);
    }

    let status = root.querySelector('.ec-releasit-offer-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'ec-releasit-offer-status';
      status.textContent = '2x1 vigente — pide hoy y paga cuando recibas';
    }
    heading.after(summary, status);
    root.querySelectorAll('.ec-releasit-offer-timer,.ec-releasit-assurance,.ec-releasit-base-price').forEach((node) => node.remove());
  };

  const offerQuantity = (offer, root) => {
    const offers = [...root.querySelectorAll('._rsi-quantity-offers-offer')];
    const position = offers.indexOf(offer);
    return OFFER_ORDER[position] || null;
  };

  const enhanceOffer = (offer, root) => {
    const quantity = offerQuantity(offer, root);
    const copy = OFFER_COPY[quantity];
    if (!copy) return;

    const title = findFirst(offer, ['._rsi-quantity-offers-title', '[class*="quantity-offers-title"]']);
    if (title) {
      title.textContent = copy.title;
      title.dataset.ecOfferCopy = 'true';
    }

    const plaque = findFirst(offer, ['._rsi-quantity-offers-plaque', '[class*="quantity-offers-plaque"]']);
    if (plaque) {
      plaque.textContent = copy.plaque;
      plaque.dataset.ecOfferCopy = 'true';
    }

    const info = findFirst(offer, ['._rsi-quantity-offers-info', '[class*="quantity-offers-info"]']);
    if (info) {
      let detail = info.querySelector('.ec-releasit-offer-detail');
      if (!detail) {
        detail = document.createElement('div');
        detail.className = 'ec-releasit-offer-detail';
        info.append(detail);
      }
      detail.textContent = copy.detail;
    }

    const image = findFirst(offer, ['img._rsi-modal-line-item-image', 'img[class*="modal-line-item-image"]']);
    if (image && copy.image) {
      image.src = copy.image;
      image.removeAttribute('srcset');
      image.alt = `Recibes ${quantity} EncíaCalm`;
      image.loading = 'lazy';
      image.decoding = 'async';
    }
  };

  let activeRoot = null;
  let hydrationObserver = null;
  let discoveryObserver = null;

  const stopHydrationObserver = () => {
    if (hydrationObserver) hydrationObserver.disconnect();
    hydrationObserver = null;
  };

  const enhance = () => {
    if (!onProductPage()) return;
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (!root) return;
    const offers = root.querySelectorAll('._rsi-quantity-offers-offer');
    if (offers.length < OFFER_ORDER.length) return;
    activeRoot = root;
    root.dataset.ecEnhanced = 'true';
    ensureOfferIntro(root);
    ensureDeliveryCopy(root);
    ensureEmailOptional(root);
    ensureSubmitCopy(root);
    offers.forEach((offer) => enhanceOffer(offer, root));
  };

  let queued = false;
  let hydrationRetry = null;
  let hydrationAttempts = 0;
  const stopHydrationRetry = () => {
    if (hydrationRetry) window.clearTimeout(hydrationRetry);
    hydrationRetry = null;
    hydrationAttempts = 0;
  };
  const scheduleHydrationRetry = () => {
    if (hydrationRetry || hydrationAttempts >= 60) return;
    hydrationAttempts += 1;
    hydrationRetry = window.setTimeout(() => {
      hydrationRetry = null;
      queueEnhance();
    }, 500);
  };
  const queueEnhance = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      enhance();
      const root = document.querySelector('#_rsi-cod-form-modal');
      if (root && root.querySelectorAll('._rsi-quantity-offers-offer').length < OFFER_ORDER.length) {
        scheduleHydrationRetry();
      } else if (root?.dataset.ecEnhanced === 'true') {
        stopHydrationRetry();
      }
    });
  };

  const watchModalHydration = (root) => {
    if (!root) return;
    if (root !== activeRoot || !hydrationObserver) {
      stopHydrationObserver();
      activeRoot = root;
      hydrationObserver = new MutationObserver(queueEnhance);
      hydrationObserver.observe(root, { childList: true, subtree: true });
    }
    queueEnhance();
  };

  const ensureDiscoveryObserver = () => {
    if (discoveryObserver || !document.body) return;
    discoveryObserver = new MutationObserver(() => {
      const modal = document.querySelector('#_rsi-cod-form-modal');
      if (modal && modal !== activeRoot) watchModalHydration(modal);
    });
    discoveryObserver.observe(document.body, { childList: true });
  };

  const discoverModal = () => {
    ensureDiscoveryObserver();
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (root) {
      hydrationAttempts = 0;
      watchModalHydration(root);
      scheduleHydrationRetry();
    }
  };

  const refreshAfterOfferInteraction = (event) => {
    if (!event.target.closest('#_rsi-cod-form-modal')) return;
    queueEnhance();
    window.setTimeout(queueEnhance, 120);
    window.setTimeout(queueEnhance, 350);
  };

  const enhancePurchaseControls = () => {
    document.querySelectorAll('._rsi-buy-now-button').forEach((button) => {
      if (!button.hasAttribute('role')) button.setAttribute('role', 'button');
      if (!button.hasAttribute('tabindex')) button.setAttribute('tabindex', '0');
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', 'Abrir formulario de pedido y ver ofertas');
      button.dataset.ecKeyboardReady = 'semantic-only';
    });
  };

  let purchaseControlObserver = null;
  let purchaseControlTimeout = null;
  const stopPurchaseControlObserver = () => {
    if (purchaseControlObserver) purchaseControlObserver.disconnect();
    purchaseControlObserver = null;
    if (purchaseControlTimeout) window.clearTimeout(purchaseControlTimeout);
    purchaseControlTimeout = null;
  };
  const discoverPurchaseControls = () => {
    enhancePurchaseControls();
    if (document.querySelector('._rsi-buy-now-button')) {
      stopPurchaseControlObserver();
      return;
    }
    if (purchaseControlObserver || !document.body) return;
    purchaseControlObserver = new MutationObserver(() => {
      enhancePurchaseControls();
      if (document.querySelector('._rsi-buy-now-button')) stopPurchaseControlObserver();
    });
    purchaseControlObserver.observe(document.body, { childList: true, subtree: true });
    purchaseControlTimeout = window.setTimeout(stopPurchaseControlObserver, 5000);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('._rsi-buy-now-button')) discoverModal(true);
    refreshAfterOfferInteraction(event);
  }, true);
  document.addEventListener('change', refreshAfterOfferInteraction, true);
  const initialize = () => {
    discoverPurchaseControls();
    discoverModal(false);
  };
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('startasyncloading', discoverPurchaseControls, { once: true });
  window.addEventListener('load', discoverPurchaseControls, { once: true });
  if (document.readyState !== 'loading') initialize();
})();
